import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import $ from 'jquery';

const initKavinetSwiper = () => {
  $('.kavinet-swiper-container').each(function () {
    const $el = $(this);
    const config = $el.data();

    // Xử lý Rows > 1 (Chunking)
    if (config.rows > 1) {
      const $wrapper = $el.find('.swiper-wrapper');
      const $slides = $wrapper.find('.swiper-slide');
      $wrapper.empty();
      for (let i = 0; i < $slides.length; i += config.rows) {
        const $group = $('<div class="swiper-slide"><div class="d-flex flex-column"></div></div>');
        $slides.slice(i, i + config.rows).addClass('mb-3').appendTo($group.find('.d-flex'));
        $wrapper.append($group);
      }
    }

    new Swiper($el.find('.kavinet-swiper')[0], {
      modules: [Navigation, Pagination, Autoplay],
      breakpoints: {
        320: { slidesPerView: config.columnsMb || 2, spaceBetween: config.gutterMb || 12 },
        1200: { slidesPerView: config.columns || 4, spaceBetween: config.gutterXl || 16 }
      },
      autoplay: config.autoplay ? { delay: 3000 } : false,
      navigation: {
        nextEl: $el.find('.swiper-button-next')[0] || null,
        prevEl: $el.find('.swiper-button-prev')[0] || null,
      },
      pagination: {
        el: $el.find('.swiper-pagination')[0] || null,
        clickable: true,
      },
      on: {
        init: function () {
          $el.closest('section').find('.swiper-preloader').remove();
          $el.removeClass('d-none').addClass('is-initialized');
        }
      }
    });
  });
};

// Chạy khi DOM sẵn sàng
$(() => {
  initKavinetSwiper();
});